import { soundEngine } from '@/sound-engine.js';
import emptyStandardExerciseScores from '../assets/data/emptyStandardExerciseScores.js';
export default {
  // Standard Level language package with title, description etc..
  standardLevelsCompareIntervalSizes: [],
  standardLevelsIdentifyIntervals: [],
  standardLevelsIdentifyChords: [],
  standardLevelsIdentifyChordInversions: [],
  standardLevelsIdentifyScales: [],  
  // Standard Level data package with title, description etc..
  standardLevelsCompareIntervalSizesData: [],
  standardLevelsIdentifyIntervalsData: [],
  standardLevelsIdentifyChordsData: [],
  standardLevelsIdentifyChordInversionsData: [],
  standardLevelsIdentifyScalesData: [],
  // User created levels
  userLevelsCompareIntervalSizes: [],
  userLevelsIdentifyIntervals: [],
  userLevelsIdentifyChords: [],
  userLevelsIdentifyChordInversions: [],
  userLevelsIdentifyScales: [],
  // Standard levels score arrays
  standardExerciseScores: emptyStandardExerciseScores,

  soundSequenceNames: null,
  // currently selected levels
  currentlySelectedLevel: {
    standard: {
      CompareIntervalSizesData: {},
      IdentifyIntervalsData: {},
      IdentifyChordsData: {},
      IdentifyChordInversionsData: {},
      IdentifyScalesData: {},

      CompareIntervalSizes: null,
      IdentifyIntervals: null,
      IdentifyChords: null,
      IdentifyChordInversions: null,
      IdentifyScales: null
    },
    user: {
      CompareIntervalSizes: null,
      IdentifyIntervals: null,
      IdentifyChords: null,
      IdentifyChordInversions: null,
      IdentifyScales: null
    }    
  },
  showLevels: 'standard',
  currentRouteName: '',
  currentRoutePath: '',
  currentUserDiscipline: '',
  soundEngine: soundEngine,
  isExerciseBeingEdited: false,
  exerciseBeingEdited: null,
  // Game data

  isGameRunning: false,
  correctNotes: [],
  incorrectNotes: [],
  dotsPositionCorrect: [],
  dotsPositionIncorrect: [],
  noteRange: ['C1', 'C7'],
  progressLamps: [], //Answer lamps
  numberOfQuestions: 20,
 

  exercisePlaying: {
    exerciseInfo: {},
    exerciseData: {}
    // exerciseType: '' // standard or user
  },
  currentExerciseIndex: 0,
  disciplinePlaying: '',
  currentExerciseRandomQuestions: [], // array of random questions in current game
  questionNumberInCurrentExercise: 0,
  correctAnswer: '',
  userAnswer: '',
  soundSequenceDataForCorrectAnswer: null,
  questionStartNote: null,
  disciplineModeTonal: null,
  waitingForUserAnswer: false,
  showEvaluationPopup: false,
  currentExerciseScore: 0,
  correctAnswersInCurrentExercise: 0,
  nextQuestionText: 'Next',
  correctOrWrongAnswer: 'neutral',
  compareIntervalSizesCorrectData: null,
  compareIntervalSizesIncorrectData: null,
  answersForPossibleIdentifyChordInversions: null,
  allAnswerPossibilitiesForChordInversions: null,
  startnoteBeforeInvert: null,
  soundSequenceForIntervalAandIntervalB: null,
  gameSettings: {
    timeInterval: 600,
    volume: 80,
    playableKeyboard: true,
    playScaleOctave: true,
    autoContinue: false,
    answerSound: true
  },
  showExerciseDescription: true,
  showExerciseList: true,
  showCreateExerciseSoundSequenceList: true,
  showCreateExerciseSettings: true,
  showUserExerciseDescription: true,
  showUserExerciseList: true,

  // User login Stuff
  accessToken: null,
  user: null,
  userObject: null,
  showSignUpDialog: false,
  showLogInDialog: false,
  showUserMenu: false,
  showUserMenuDialogMobile: false,
  showLoginSignupBottomSheet: false,
  showLoginToAccessDialog: false,
  showDataCopiedToDatabaseDialog: false,
  snackbar: {},
  alertDialog: {},
  maxNumberOfUserExercises: 20,
  navigatedFromStartButton: false,
  // For determining if user has access to system
  provider: null,
  emailVerified: false

}